
export class GraphEdgeFilterOptions {
    graphEdgeIds: Array<number>;
    sourceVertexIds: Array<number>;
    targetVertexIds: Array<number>;
}
